/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DonutSegment
 */
export interface DonutSegment {
    /**
     * 
     * @type {string}
     * @memberof DonutSegment
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof DonutSegment
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof DonutSegment
     */
    percent?: number;
    /**
     * 
     * @type {string}
     * @memberof DonutSegment
     */
    sourceTechnology?: string;
}

/**
 * Check if a given object implements the DonutSegment interface.
 */
export function instanceOfDonutSegment(value: object): value is DonutSegment {
    return true;
}

export function DonutSegmentFromJSON(json: any): DonutSegment {
    return DonutSegmentFromJSONTyped(json, false);
}

export function DonutSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DonutSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        'percent': json['percent'] == null ? undefined : json['percent'],
        'sourceTechnology': json['source_technology'] == null ? undefined : json['source_technology'],
    };
}

export function DonutSegmentToJSON(json: any): DonutSegment {
    return DonutSegmentToJSONTyped(json, false);
}

export function DonutSegmentToJSONTyped(value?: DonutSegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
        'percent': value['percent'],
        'source_technology': value['sourceTechnology'],
    };
}

